import { faDoorOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import purchaseSound from '../../assets/audio/GP_Turbo_PutDown_2.wav';
import purchaseFailSound from '../../assets/audio/UI_Click_1.wav';
import navigateButton from '../../assets/audio/UI_Select_2.wav';
import CoinPath from '../../assets/images/coins.png';
import { Button, Checkbox, Col, Divider, Row, Space, Typography } from 'antd';
import { FC } from 'react';
import { Link } from 'react-router-dom';


import { useBookStore, useHeroStore, useShopStore } from '../store/game.store';

interface ShopPageProps extends React.PropsWithChildren { }
const WarScholarShopProps: FC<ShopPageProps> = () => {
   const { state: shopState, actions: shopActions } = useShopStore();

   const { state: bookState, actions: unlockActions } = useBookStore();
   const { hasUnlockedChapter2, hasUnlockedChapter3, hasUnlockedChapter4, hasUnlockedChapter5, hasUnlockedChapter6, hasUnlockedChapter7, hasUnlockedChapter8, hasUnlockedChapter9 } = bookState;

   const { state: heroState, actions: heroActions } = useHeroStore();
   const { attackSkillsUnlocked, defenceSkillsUnlocked, fortitudeSkillsUnlocked, wayfindingSkill, combatSpeedSkillsUnlocked, potionCapacitySkillsUnlocked, potionMaxCapacity, potionAvailable } = heroState;

   const handlePotionPurchase = (incomingGoldCost: number) => (event: any) => {
      if (potionAvailable < potionMaxCapacity) {
         if (shopState.gold >= incomingGoldCost) {
            new Audio(purchaseSound).play();
            shopActions.spendGold({ spent: incomingGoldCost });
            heroActions.heroUnlockActions.buyPotion();
         } else {
            new Audio(purchaseFailSound).play();
         }
      } else {
         new Audio(purchaseFailSound).play();
      }
   };

   const handleChapterPurchase = (incomingGoldCost: number) => (event: any) => {
      if (!hasUnlockedChapter9) {
         if (shopState.gold >= incomingGoldCost) {
            new Audio(purchaseSound).play();
            shopActions.spendGold({ spent: incomingGoldCost });
            unlockActions.buyNextChapter();
         } else {
            new Audio(purchaseFailSound).play();
         }
      } else {
         new Audio(purchaseFailSound).play();
      }
   };

   const handleAttackSkillPurchase = (incomingGoldCost: number) => (event: any) => {
      if (attackSkillsUnlocked.length < 3) {
         if (shopState.gold >= incomingGoldCost) {
            new Audio(purchaseSound).play();
            shopActions.spendGold({ spent: incomingGoldCost });
            heroActions.heroUnlockActions.buyNextAttackSkill();
         } else {
            new Audio(purchaseFailSound).play();
         }
      } else {
         new Audio(purchaseFailSound).play();
      }
   };

   const handleDefenceSkillPurchase = (incomingGoldCost: number) => (event: any) => {
      if (defenceSkillsUnlocked.length < 3) {
         if (shopState.gold >= incomingGoldCost) {
            new Audio(purchaseSound).play();
            shopActions.spendGold({ spent: incomingGoldCost });
            heroActions.heroUnlockActions.buyNextDefenceSkill();
         } else {
            new Audio(purchaseFailSound).play();
         }
      } else {
         new Audio(purchaseFailSound).play();
      }
   };

   const handleFortitudeSkillPurchase = (incomingGoldCost: number) => (event: any) => {
      if (fortitudeSkillsUnlocked.length < 5) {
         if (shopState.gold >= incomingGoldCost) {
            new Audio(purchaseSound).play();
            shopActions.spendGold({ spent: incomingGoldCost });
            heroActions.heroUnlockActions.buyNextFortitudeSkill();
         } else {
            new Audio(purchaseFailSound).play();
         }
      } else {
         new Audio(purchaseFailSound).play();
      }
   };

   const handleWayfindingSkillPurchase = (incomingGoldCost: number) => (event: any) => {
      if (!wayfindingSkill) {
         if (shopState.gold >= incomingGoldCost) {
            new Audio(purchaseSound).play();
            shopActions.spendGold({ spent: incomingGoldCost });
            heroActions.heroUnlockActions.buyWayfindingSkill();
         } else {
            new Audio(purchaseFailSound).play();
         }
      } else {
         new Audio(purchaseFailSound).play();
      }
   };

   const handleCombatSpeedSkillPurchase = (incomingGoldCost: number) => (event: any) => {
      if (combatSpeedSkillsUnlocked.length < 2) {
         if (shopState.gold >= incomingGoldCost) {
            new Audio(purchaseSound).play();
            shopActions.spendGold({ spent: incomingGoldCost });
            heroActions.heroUnlockActions.buyNextCombatSpeedSkill();
         } else {
            new Audio(purchaseFailSound).play();
         }
      } else {
         new Audio(purchaseFailSound).play();
      }
   };

   const handlePotionCapacitySkillPurchase = (incomingGoldCost: number) => (event: any) => {
      if (potionCapacitySkillsUnlocked.length < 2) {
         if (shopState.gold >= incomingGoldCost) {
            new Audio(purchaseSound).play();
            shopActions.spendGold({ spent: incomingGoldCost });
            heroActions.heroUnlockActions.buyNextPotionCapacitySkill();
         } else {
            new Audio(purchaseFailSound).play();
         }
      } else {
         new Audio(purchaseFailSound).play();
      }
   };

   const playNavigationSound = () => {
      new Audio(navigateButton).play();
   };

   return (
      <div className='p-2'>
         <Space size="small">
            <Typography.Title>Shop</Typography.Title>
            <img
               src={CoinPath}
               alt="coins"
            />
            <div style={{ display: 'flex', justifyContent: 'center' }}>{shopState.gold} gold</div>
         </Space>

         <Link to="/warscholar">
            <button onClick={playNavigationSound}>
               <FontAwesomeIcon icon={faDoorOpen} /> Back
            </button>
         </Link>

         <div>
            <Row gutter={[16, 24]}>
               <Col span={8}>
                  <h4>Health Potion</h4>
                  <Button onClick={handlePotionPurchase(25)}>25 gold</Button>
               </Col>
               <Col span={8}>
                  <Checkbox
                     disabled
                     checked={potionAvailable === 1 || potionAvailable > 1}
                  >
                     potion
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={potionAvailable === 2 || potionAvailable > 2}
                  >
                     potion
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={potionAvailable === 3}
                  >
                     potion
                  </Checkbox>
               </Col>
            </Row>
         </div>
         <Divider />

         <div>
            <Row gutter={[16, 24]}>
               <Col span={8}>
                  <h4>Potion Capacity</h4>
                  <Button onClick={handlePotionCapacitySkillPurchase(130)}>130 gold</Button>
               </Col>
               <Col span={8}>
                  <Checkbox
                     disabled
                     checked={potionCapacitySkillsUnlocked.length === 0}
                  >
                     1 potion capacity
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={potionCapacitySkillsUnlocked.length === 1}
                  >
                     2 potion capacity
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={potionCapacitySkillsUnlocked.length === 2}
                  >
                     3 potion capacity
                  </Checkbox>
               </Col>
            </Row>
         </div>
         <Divider />

         <div>
            <Row gutter={[16, 24]}>
               <Col span={8}>
                  <h4>Attack Skill Training</h4>
                  <Button onClick={handleAttackSkillPurchase(40)}>40 gold</Button>
               </Col>
               <Col span={8}>
                  <Checkbox
                     disabled
                     checked={attackSkillsUnlocked.length === 1}
                  >
                     + 1 damage
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={attackSkillsUnlocked.length === 2}
                  >
                     + 2 damage
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={attackSkillsUnlocked.length === 3}
                  >
                     + 3 damage
                  </Checkbox>
               </Col>
            </Row>
         </div>
         <Divider />

         <div>
            <Row gutter={[16, 24]}>
               <Col span={8}>
                  <h4>Defence Skill Training</h4>
                  <Button onClick={handleDefenceSkillPurchase(60)}>60 gold</Button>
               </Col>
               <Col span={8}>
                  <Checkbox
                     disabled
                     checked={defenceSkillsUnlocked.length === 1}
                  >
                     + 1 defence
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={defenceSkillsUnlocked.length === 2}
                  >
                     + 2 defence
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={defenceSkillsUnlocked.length === 3}
                  >
                     + 3 defence
                  </Checkbox>
               </Col>
            </Row>
         </div>
         <Divider />

         <div>
            <Row gutter={[16, 24]}>
               <Col span={8}>
                  <h4>Fortitude Skill Training</h4>
                  <Button onClick={handleFortitudeSkillPurchase(80)}>80 gold</Button>
               </Col>
               <Col span={8}>
                  <Checkbox
                     disabled
                     checked={fortitudeSkillsUnlocked.length === 1}
                  >
                     + 1 max health
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={fortitudeSkillsUnlocked.length === 2}
                  >
                     + 2 max health
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={fortitudeSkillsUnlocked.length === 3}
                  >
                     + 3 max health
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={fortitudeSkillsUnlocked.length === 4}
                  >
                     + 4 max health
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={fortitudeSkillsUnlocked.length === 5}
                  >
                     + 5 max health
                  </Checkbox>
               </Col>
            </Row>
         </div>
         <Divider />

         <div>
            <Row gutter={[16, 24]}>
               <Col span={8}>
                  <h4>WayFinding Skill Training</h4>
                  <Button onClick={handleWayfindingSkillPurchase(100)}>100 gold</Button>
               </Col>
               <Col span={8}>
                  <Checkbox
                     disabled
                     checked={wayfindingSkill}
                  >
                     {' '}
                     re-roll WayFinding checks
                  </Checkbox>
               </Col>
            </Row>
         </div>
         <Divider />

         <div>
            <Row gutter={[16, 24]}>
               <Col span={8}>
                  <h4>Combat Speed Training</h4>
                  <Button onClick={handleCombatSpeedSkillPurchase(120)}>120 gold</Button>
               </Col>
               <Col span={8}>
                  <Checkbox
                     disabled
                     checked={combatSpeedSkillsUnlocked.length === 1}
                  >
                     + 1 Action Points
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={combatSpeedSkillsUnlocked.length === 2}
                  >
                     + 2 Action Points
                  </Checkbox>
               </Col>
            </Row>
         </div>
         <Divider />

         <div>
            <Row gutter={[16, 24]}>
               <Col span={8}>
                  <h4>Book Chapter </h4>
                  <Button onClick={handleChapterPurchase(100)}>100 gold</Button>
               </Col>
               <Col span={8}>
                  <Checkbox
                     disabled
                     checked
                  >
                     Chapter 1
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={hasUnlockedChapter2}
                  >
                     Chapter 2
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={hasUnlockedChapter3}
                  >
                     Chapter 3
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={hasUnlockedChapter4}
                  >
                     Chapter 4
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={hasUnlockedChapter5}
                  >
                     Chapter 5
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={hasUnlockedChapter6}
                  >
                     Chapter 6
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={hasUnlockedChapter7}
                  >
                     Chapter 7
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={hasUnlockedChapter8}
                  >
                     Chapter 8
                  </Checkbox>
                  <Checkbox
                     disabled
                     checked={hasUnlockedChapter9}
                  >
                     Chapter 9
                  </Checkbox>
               </Col>
            </Row>
         </div>
         <Divider />
      </div>
   );
};

export const WarScholarShopPage =  WarScholarShopProps;
